var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conditions-container"},[(_vm.lang === 'en')?_c('EnPage'):_c('KrPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }